export default __webpack_public_path__ + "static/media/happy_people.590e88fc.png";